import { Component } from '@angular/core';
import { UpsellCardComponent } from '@components/upsell-card/upsell-card.component';
import { UpsellSlugs } from '@enums/upsell-slugs';

@Component({
  selector: 'app-expedited-shipping',
  imports: [UpsellCardComponent],
  templateUrl: './expedited-shipping.component.html',
})
export class ExpeditedShippingComponent {
  public readonly slug: UpsellSlugs = UpsellSlugs.OvernightShipping;
}
